import React, { useEffect, useState } from 'react';

import { NakedIcon } from 'theme/icons';
import { Colors } from 'theme/colors';
import { InlineError, InlineErrorContainer } from './styles';

/**
 * Renders an input error message with slide in/out animation
 *
 * @param props - Error message props
 * @returns Error message component
 */
export function ErrorMessage(props: Props) {
  const { message, errorPosition } = props;
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [displayMessage, setDisplayMessage] = useState('');

  useEffect(() => {
    if (message) {
      // Store the message and start rendering
      setDisplayMessage(message);
      setShouldRender(true);
      // Use setTimeout to ensure DOM is ready before animating
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 10);
      return () => clearTimeout(timer);
    } else {
      // Animate out first, then remove from DOM
      // Keep the message text visible during fade-out
      setIsVisible(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
        setDisplayMessage('');
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (!shouldRender) {
    return null;
  }

  return (
    <InlineErrorContainer position={errorPosition} isVisible={isVisible}>
      <NakedIcon name="close" size={8} color={Colors.red} width={13} />
      <InlineError>{displayMessage}</InlineError>
    </InlineErrorContainer>
  );
}
/** Type definitions */
interface Props {
  /** Error message */
  message?: string;
  /** Position the error */
  errorPosition?: string;
}
